import React from 'react';

type InfoProps = {
  title: string;
  description: string;
  className?: string;
  superHeader?: string;
};

const BigHeader: React.FC<InfoProps> = ({ title, description, superHeader, className = '' }) => {
  return (
    <div className={className}>
      {superHeader ? (
        <>
          <h2 className="mb-12 text-sm font-semibold uppercase tracking-widest text-blue-600">{superHeader}</h2>
          <h3 className="mb-2 max-w-3xl text-3xl font-normal leading-tight text-black md:text-4xl md:font-light xl:text-5xl">
            {title}
          </h3>
        </>
      ) : (
        <h2 className="mb-2 text-3xl font-normal leading-tight text-yellow-600 md:text-4xl md:font-light xl:text-5xl">
          {title}
        </h2>
      )}
      <p className="mt-2 w-full mx-auto max-w-3xl text-base text-gray-600 sm:text-lg md:text-xl">
        {description}
      </p>
    </div>
  );
};

export default BigHeader;
